<!-- Screenname: Schedule Master Creation -->
<template>
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="
      model
        ? t('Items.ScheduleMaster.EditScheduleMaster')
        : t('Items.ScheduleMaster.CreateScheduleMaster')
    "
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              v-model="insert_data.Name"
              type="text"
              :label="t('Items.ScheduleMaster.Name')"
              clearable
              id="Name"
              name="Name"
              :rules="{ required: true }"
              :required-icon="true"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <div class="field">
            <TextField
              v-model="insert_data.ColorCode"
              type="text"
              :label="t('Items.ScheduleMaster.ColorCode')"
              clearable
              id="ColorCode"
              name="ColorCode"
              :rules="{ required: false }"
              :required-icon="false"
            />
          </div>
        </b-col>
        <b-col sm="6" class="d-flex align-items-center">
          <div class="field mb-1">
            <Checkbox
              v-model="insert_data.IsSchedule"
              :binary="true"
              id="IsSchedule"
              name="IsSchedule" inputId="schedule"
            />
          </div>
            <label for="schedule"> {{ t('Items.ScheduleMaster.IsSchedule') }} </label>

        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <Footer
            @cancel="IsClear()"
            :cancelhide="false"
            :label="label"
            :loading="Saveloading"
          />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import axios from "axios";
import service from "../../../../Service/ScheduleMasterService";
import { useRoute } from "vue-router";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from 'vue-i18n';
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";

export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Footer,
    axios,
    useRoute,
    TextField,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
  },
  setup(props, { emit }) {
    debugger;

    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;

    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let Saveloading = ref(false);

    const insert_data = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      Id: 0,
      Code: "",
      Name: "",
      ColorCode: "",
      IsSchedule: false,
      EntityId: 0,
      EntityOperationId: 0,
    });

    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }

    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });

    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      } else if (event.altKey && event.key == "n") {
        showDialog.value = true;
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    const copyinsert_data = JSON.parse(JSON.stringify(insert_data.value));
    function IsClear() {
      Object.assign(insert_data.value, copyinsert_data);
      insert_data.value.Id = 0;
      showDialog.value = false;
      emit("update:selectedItem", undefined);
      emit("close");
    }

    function IsCreate() {
      debugger;
      showDialog.value = true;
      GetCode();
    }

    async function IsEdit() {
      debugger;
      emit("loadershow");
      try {
        label.value = t("btn.update");
        const EditId = model.value.Id;
        const response = await service.Edit(EditId);
        const data = response["result"];
        console.log(response["result"]);

        Object.keys(insert_data.value).forEach((key) => {
          if (data[key]) insert_data.value[key] = data[key];
        });

        emit("loaderhide");
        showDialog.value = true;
      } catch (error) {
        emit("loaderhide");
        alert(error);
      }
    }

    const IsSubmit = handleSubmit(async (values) => {
      Saveloading.value = true;
      emit("loadershow");
      try {
        let msg = "";
        insert_data.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        insert_data.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        insert_data.value.BranchId = 0;
        insert_data.value.HospitalId = HospitalId;
        insert_data.value.ModifiedBy = UserId;
        insert_data.value.CreatedBy = UserId;
        insert_data.value.EntityId = Number(Entitydata.value.EntityId);
        if (insert_data.value.Id != 0) {
          insert_data.value.EntityOperationId = props.OperationID.UpdateId;
          const data_response = await service.Update(insert_data.value);
          msg = data_response["ErrorInfo"].ErrorCode;
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            emit("loaderhide");
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            emit("loaderhide");
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          insert_data.value.EntityOperationId = props.OperationID.CreateId;
          const data_response = await service.insert(insert_data.value);
          msg = data_response["ErrorInfo"].ErrorCode;
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            emit("loaderhide");
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            emit("loaderhide");
            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        Saveloading.value = false;
        emit("loaderhide");
        console.log(error);
      }
    });

    async function GetCode() {
      debugger;
      let data = {
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      insert_data.value.Code = result;
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      showDialog.value = false;
      emit("load");
      IsClear();
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      insert_data.value.Name = "";
    }

    return {
      model,
      showModal: ref(false),
      insert_data,
      IsSubmit,
      IsEdit,
      IsClear,
      showDialog,
      IsCreate,
      GetCode,
      successpop,
      updatepop,
      alreadyexistpop,
      closetrigger,
      alreadyclosetrigger,
      label,
      Saveloading,
      t
    };
  },
});
</script>
